import Clinic from './clinic';
import Workflow from './workflow';
import { ExperianQuestion } from './question';

export default class Provider {
    public firstName: string;
    public lastName: string;
    public dob: string;
    public specialty: string;
    public clinicName: string;
    public homeAddressLine1: string;
    public homeAddressLine2?: string;
    public homeCity: string;
    public homeState: string;
    public homeZipCode: string;
    public homePhone: string;
    public ssn: string;
    public email: string;
    public stateLicense: string;
    public issuingState: string;
    public expDate: string;
    public dea: string;
    public deaExpDate: string;
    public degree: string;
    public npi: string;
    public taxId: string;

    public clinics: Array<Clinic>;

    public uploadFile: UploadFileRequestWithoutRegId;
    public uploadVideo: UploadFileRequestWithoutRegId;
}

export interface UploadFileRequestWithoutRegId {
    name: string;
    fileName: string;
    description?: string;
    url: string;
    fileSize: number;
}

export interface ProviderInfoResponse {
    registrationId: string;
    emailIsValid: boolean;
    userInfo: string;
    workflow: Workflow;
    questionSet: Array<ExperianQuestion>;
    success: boolean;
    message: string;
    statusCode?: number;
}

export enum ProviderInfoResponseStatusCode {
    Success = 200,
    Error_ExistUser = 405,
    Error_TerminatedUser = 406,
    Error_General = 500
}

export interface ProviderInfoPayment {
    physicianName: string;
    physicianEmail: string;
    clinics?: Array<Clinic>;
    physicianLastName?: string;
}

export interface SubmitToVendorResponse {
    success: boolean;
    message: string;
}

// New Step01
export class ProviderInformationRequest {
    public firstName: string;
    public lastName: string;
    public dob: string;
    public specialty: string;
    public homeAddressLine1: string;
    public homeAddressLine2?: string;
    public homeCity: string;
    public homeState: string;
    public homeZipCode: string;
    public homePhone: string;
    public ssn: string;
    public email: string;
    public degree: string;
    public taxId: string;

    public uploadFile: UploadFileRequestWithoutRegId;
}


// WEBPACK FOOTER //
// ./src/models/provider.ts